import React from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
 
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const SignupSchema = Yup.object().shape({
   firstName: Yup.string()
     .min(2, 'Too Short!')
     .max(50, 'Too Long!')
     .required('Required'),
   lastName: Yup.string()
     .min(2, 'Too Short!')
     .max(50, 'Too Long!')
     .required('Required'),
   email: Yup.string().email('Invalid email').required('Required'),
 });

function index() {
    return (
        <div>
            <Formik
                initialValues={{
                    firstName: '',
                    lastName: '',
                    email: '',
                }}
                validationSchema={SignupSchema}
                onSubmit={async (values) => {
                    // await sleep(500);
                    alert(JSON.stringify(values, null, 2));
                }}
                >
                {({ isSubmitting, errors, touched, values }) => (
                    <Form>
                        <div className="form-group icon-input mb-1">
                            <Field 
                                type="text" 
                                name="email" 
                                placeholder="Email"  
                                className="style2-input ps-5 form-control text-grey-900 font-xss ls-3"    
                            />
                            <i className="font-sm ti-lock text-grey-500 pe-0"></i>
                        </div>                    
                        {errors.email && touched.email ? <div>{errors.email}</div> : null}
                        <div className="form-group icon-input mb-1">
                            <Field 
                                type="Password" 
                                name="lastName" 
                                placeholder="Contraseña"  
                                className="style2-input ps-5 form-control text-grey-900 font-xss ls-3"    
                            />
                            <i className="font-sm ti-lock text-grey-500 pe-0"></i>
                        </div>                    
                        {errors.lastName && touched.lastName ? (
                            <div>{errors.lastName}</div>
                        ) : null}
                    <div className="form-check text-left mb-3">
                        <Field type="checkbox" name="toggle" className="form-check-input mt-2"/>
                        <label className="form-check-label font-xsss text-grey-500">Recuerdame</label>
                        <a href="/forgot" className="fw-600 font-xsss text-grey-700 mt-1 float-right">Olvidaste tu contraseña?</a>
                    </div>
                    <div className="col-sm-12 p-0 text-left">
                        <div className="form-group mb-1"><button type="submit" disabled={isSubmitting} className="form-control text-center style2-input text-white fw-600 bg-dark border-0 p-0 ">Login</button></div>
                        <h6 className="text-grey-500 font-xsss fw-500 mt-0 mb-0 lh-32">No tienes cuenta <a href="/register" className="fw-700 ms-1">Registrate</a></h6>
                    </div>
                    </Form>
                )}
                </Formik>
        </div>
    )
}

export default index
